<template>
  <div class="row font-fira">
    <img class="img col-12 col-md-4" :src="getImage(item)" />
    <div class="col-12 col-md-8 h-100">
      <div class="row mt-2 mb-3">
        <div class="col d-flex justify-content-end">
          <b-button
            variant="warning"
            class="mr-3"
            @click="$bvModal.hide('shop-details')"
            ><b-icon-x-square></b-icon-x-square>
            {{ $t("shop.close") }}</b-button
          >
          <b-button variant="success" @click="addItem(item)" v-if="!item.soldOut"
            ><b-icon-cart></b-icon-cart> {{ $t("shop.buy") }}</b-button
          >
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-3 font-weight-bold">
          {{ $t("shop.title") }}:
        </div>
        <div class="col-12 col-md-9">{{ item.title }}</div>
      </div>
      <div class="row" v-if="item.autor">
        <div class="col-12 col-md-3 font-weight-bold">Autor:</div>
        <div class="col-12 col-md-9">{{ item.autor }}</div>
      </div>
      <div class="row" v-if="item.editor">
        <div class="col-12 col-md-3 font-weight-bold">Editor:</div>
        <div class="col-12 col-md-9">{{ item.editor }}</div>
      </div>
      <div class="row" v-if="item.concept">
        <div class="col-12 col-md-3 font-weight-bold">Concept:</div>
        <div class="col-12 col-md-9">{{ item.concept }}</div>
      </div>
      <div class="row" v-if="item.proofreading">
        <div class="col-12 col-md-3 font-weight-bold">Prelucrare texte, corectură:</div>
        <div class="col-12 col-md-9">{{ item.proofreading }}</div>
      </div>
      <div class="row" v-if="item.printing">
        <div class="col-12 col-md-3 font-weight-bold">Tipar:</div>
        <div class="col-12 col-md-9">{{ item.printing }}</div>
      </div>
      <div class="row" v-if="item.artist">
        <div class="col-12 col-md-3 font-weight-bold">Artist:</div>
        <div class="col-12 col-md-9">{{ item.artist }}</div>
      </div>
      <div class="row" v-if="item.conductor">
        <div class="col-12 col-md-3 font-weight-bold">
          {{ $t("shop.conductor") }}:
        </div>
        <div class="col-12 col-md-9">{{ item.conductor }}</div>
      </div>
      <div class="row my-3">
        <div class="col-12 col-md-3 font-weight-bold">
          {{ $t("shop.itemPrice") }}:
        </div>
        <div class="col-12 col-md-9 font-weight-bold">
          {{ item.price
          }}<small
            v-if="item.oldPrice"
            style="text-decoration: line-through"
            class="ml-1"
            >{{ item.oldPrice }}</small
          >
          RON
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-3 font-weight-bold">
          {{ $t("shop.description") }}:
        </div>
        <div class="col-12 col-md-9">
          <p v-for="i of item.description" :key="i">{{ i }}</p>
        </div>
      </div>
      <div class="row" v-if="item.playlist && item.playlist.length > 0">
        <div class="col-12 col-md-3 font-weight-bold">Playlist:</div>
        <div class="col-12 col-md-9">
          <p v-for="i of item.playlist" :key="i">{{ i }}</p>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col d-flex justify-content-end">
          <b-button
            variant="warning"
            class="mr-3"
            @click="$bvModal.hide('shop-details')"
            ><b-icon-x-square></b-icon-x-square>
            {{ $t("shop.close") }}</b-button
          >
          <b-button variant="success" @click="addItem(item)"
            ><b-icon-cart></b-icon-cart> {{ $t("shop.buy") }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopDetails",
  props: ["item"],
  methods: {
    getImage(item) {
      return require(`../assets/images/shop/${item.image}`);
    },
    addItem(item) {
      this.$bvModal.hide("shop-details");
      this.$store.dispatch("cart/addProductToCart", item);
    },
  },
};
</script>

<style scoped>
div {
  color: #3d5262;
  font-size: 1.2rem;
  line-height: 1.5rem;
}

.img {
  object-fit: contain;
  object-position: top;
}
</style>
